import { AxiosError } from "axios";

class HTTPErrorHandlerService {
  public handle(error: AxiosError): void {
    // handle API call errors here if needed
  }
}

export const httpErrorHandlerService = new HTTPErrorHandlerService();
